<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'App',
  methods:{
     ...mapActions(['handleHomeData']),
  },
  created(){
    if (!this.$store.state.menuBar) {
      this.handleHomeData()
    }
  }
}
</script>
